import { useMemo } from "react";
import { formatCPF } from "@brazilian-utils/brazilian-utils";
import { SolicitacaoCadastroListItem } from "core/features/SolicitacaoCadastro/typings";

function useSolicitacaoCadastroColumns() {
  return useMemo(() => {
    return [
      {
        title: "USUÁRIO",
        dataIndex: "nome",
      },
      {
        title: "CPF",
        accessor: "cpf",
        render: (original: SolicitacaoCadastroListItem) => (
          <div>{formatCPF(original.cpf)}</div>
        ),
      },
      {
        title: "E-mail",
        dataIndex: "email",
      },
      {
        title: "Status",
        render: (original: SolicitacaoCadastroListItem) => (
          <div>{original.status.nome}</div>
        ),
      },
    ];
  }, []);
}

export default useSolicitacaoCadastroColumns;
